import HooksModalV5Key from "app/constants/HooksModalV5Key";
import { useStorage } from "app/custom-hooks/storage/useStorage";
import FeatureUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/components/FeatureUpgradeBanner/FeatureUpgradeBanner";
import trackingService from "app/pages/sales-intelligence/common-components/feature-upgrade/services/tracking/trackingService";
import { appsSearchSessionStorage } from "app/pages/sales-intelligence/modules/apps-search/services/storage";
import { featureHookKeys } from "app/pages/sales-intelligence/utils/i18n/feature-hook";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import appsSearchFiltersI18nKeys from "../../utils/i18n";

export const AppsFeatureUpgradeView = () => {
    const [isAppsHookSubmitted, setIsAppsHookSubmitted] = useStorage(appsSearchSessionStorage.appsFeatureRequestSent);

    const handleOnSubmit = () => {
        trackingService.trackFeatureAccessRequested(HooksModalV5Key.AppLeadGenerator);
        void requestFeature(HooksModalV5Key.AppLeadGenerator);
        setIsAppsHookSubmitted(true);
    };

    return (
        <FeatureUpgradeBanner
            isSubmitted={isAppsHookSubmitted}
            titleKey={appsSearchFiltersI18nKeys.upgradeBanner.title}
            subtitleKey={appsSearchFiltersI18nKeys.upgradeBanner.subtitle}
            buttonTextKey={featureHookKeys.speakWithUsCta}
            onSubmit={handleOnSubmit}
        />
    );
};
